<template>
  <Card>
    <Table :columns="column" :data="list">
      <template slot-scope="{ row }" slot="name">
        {{ row.resume && row.resume.name }}
      </template>

      <template slot-scope="{ row }" slot="sex">
        {{ row.resume && row.resume.sex }}
      </template>

      <template slot-scope="{ row }" slot="age">
        {{ row.resume && row.resume.age }}
      </template>

      <template slot-scope="{ row }" slot="jobName">
        {{ row.job.title }}
      </template>

      <template slot-scope="{ row }" slot="degree">
        {{ row.resume && row.resume.degree }}
      </template>

      <template slot-scope="{ row }" slot="interviewTime">
        {{ row.interviewTime | formatTime }}
      </template>

      <template slot-scope="{ row }" slot="status">
        <Tag type="border" v-if="row.interviewStatus === 1" color="blue">待处理</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 2" color="green">已面试</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 3" color="red">已取消</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 4" color="red">已拒绝</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 5" color="yellow">待面试</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 6" color="red">面试未通过</Tag>
        <Tag type="border" v-else-if="row.interviewStatus === 7" color="green">面试通过</Tag>
      </template>

      <template slot-scope="{ row }" slot="interviewType">
        {{ row.interviewType === 1 ? '线上面试' : '现场到面' }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <div>
          <Poptip placement="bottom-start" :transfer="true">
            <a class="action" v-if="row.interviewStatus !== 4">修改面试状态</a>
            <div slot="content">
              <RadioGroup v-model="row.interviewStatus" vertical @on-change="changeStatus(row)">
                <Radio :label="2">已面试</Radio>
                <Radio :label="3">已取消</Radio>
                <Radio :label="6">未录取</Radio>
                <Radio :label="7">已录取</Radio>
              </RadioGroup>
            </div>
          </Poptip>
          <a class="action" @click="showResume(row)" v-if="row.resume">查看简历</a>
          <a class="action" @click="sayHi(row.jobApplicantId, row.jobId)">沟通</a>
          <a class="action" @click="toOnline(row)" v-if="row.interviewType === 1">进入面试</a>
        </div>
      </template>
    </Table>
    <Page
      v-if="pagination.count"
      style="padding: 10px; background: #fff"
      class="page"
      @on-change="changePage"
      :total="pagination.count"
      :page-size="pagination.pageSize"
      size="small"
      show-elevator
    />

    <!-- <Modal width="500" v-model="jujue" title="确请填写拒绝备注" @on-ok="ok" :closable="false">
      <Input :rows="4" v-model="value" type="textarea" placeholder="请填写您要备注的内容"></Input>
    </Modal> -->
    <Modal class="interview-modal" title="邀请参加面试" v-model="showInterviewModal" :closable="false" footer-hide>
      <inter-view @cancle="cancle" :info="info.resume" @sent="sent"></inter-view>
    </Modal>
    <Modal v-model="showResumeModal" :width="700" :footer-hide="true" title="查看简历">
      <resume v-if="info" :info="info.resume" :file="info.fileUrl" :job-id="info.jobId" :noInterview="0" @invite="yuyue"></resume>
    </Modal>
  </Card>
</template>

<script>
import { getDate, downloadFile } from '@/libs/index';
import interView from '@/components/interview/interview';
import { mapState } from 'vuex';
import resumeaction from '@/view/components/resumemixin';
import resume from '@/view/components/resume';
import { TUIStore, StoreName, TUIConversationService, TUIChatService } from '@tencentcloud/chat-uikit-engine';

export default {
  mixins: [resumeaction],
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        idOrder: 'desc',
        ageMin: undefined,
        ageMax: undefined
      },
      list: [],
      value: '',
      jujue: false,
      id: '',
      pagination: {},
      showInterviewModal: false,
      form: {},
      jobId: this.$route.query.jobId,
      showResumeModal: false,
      info: { resume: {} },
      url: '',
      degrees: [],
      jobs: [],

      column: [
        { title: '面试岗位', slot: 'jobName', width: 140 },
        { title: '状态', slot: 'status', width: 120 },
        { title: '姓名', slot: 'name', width: 80 },
        { title: '性别', slot: 'sex', width: 50 },
        { title: '年龄', slot: 'age', width: 50 },
        { title: '学历', slot: 'degree', width: 80 },
        { title: '面试时间', slot: 'interviewTime', width: 120 },
        { title: '面试类型', slot: 'interviewType', width: 80 },
        { title: '地址', key: 'address', width: 200 },
        // {
        //   title: '面试状态',
        //   width: 90,
        //   fixed: 'right',
        //   slot: 'setStatus'
        // },
        {
          title: '操作',
          minWidth: 270,
          fixed: 'right',
          slot: 'action'
        }
      ]
    };
  },
  watch: {
    $route: {
      immediate: true, // 立即触发一次
      deep: true, // 深度观察，确保嵌套对象如query的改变也能触发
      handler(newRoute, oldRoute) {
        if (newRoute.query.jobId) {
          this.queryParams.jobId = parseInt(newRoute.query.jobId);
        } else {
          this.queryParams.jobId = undefined;
        }
        if (newRoute.query.id) {
          this.queryParams.id = parseInt(newRoute.query.id);
        } else {
          this.queryParams.id = undefined;
        }
        this.getList();
      }
    }
  },
  components: {
    interView,
    resume
  },
  computed: {
    ...mapState({
      timPrefix: state => state.user.timPrefix,
      userProfile: state => state.user.userProfile
    })
  },
  mounted() {
    this.getList();
    // this.getDegree();
    this.getPositionList();
  },
  methods: {
    changeStatus(row) {
      this.$axios
        .request({
          url: 'front/v1/interview/updateStatus',
          method: 'post',
          data: {
            id: row.id,
            status: row.interviewStatus
          }
        })
        .then(res => {});
    },
    toOnline(row) {
      this.sayHi(row.jobApplicantId, row.jobId);
      localStorage.setItem('videoCall', true);
    },
    getPositionList() {
      this.$axios
        .request({
          url: 'front/v1/job',
          params: {
            pageSize: 100,
            idOrder: 'desc'
          }
        })
        .then(res => {
          this.jobs = res.data.list;
        });
    },
    resetQueryForm() {
      this.$refs.queryForm.resetFields();
      this.getList();
    },
    showResume(item) {
      this.showResumeModal = true;
      this.info = item;
      if (item.resume && item.resume.id) {
        this.$axios.request({
          url: 'front/v1/company-resume/read',
          method: 'post',
          data: {
            id: item.resume.id
          }
        });
      }
    },
    cancle() {
      this.showInterviewModal = false;
    },
    yuyue() {
      this.showInterviewModal = true;
    },
    getList() {
      this.$axios.request({ url: 'front/v1/interview', method: 'get', params: this.queryParams }).then(res => {
        this.list = res.data.list;
        this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
      });
    },
    changePage(page) {
      this.queryParams.pageIndex = page;
      this.getList();
    },
    setStatus(status, item) {
      this.$axios
        .request({
          url: 'api/qiye/companyResume/operation',
          method: 'post',
          data: { id: item.id, status: status }
        })
        .then(res => {
          item.status = status;
          this.$Message.success('已通知对方');
        });
    },
    ok() {
      return;
      this.$axios
        .request({
          url: 'api/qiye/companyResume/operation',
          method: 'post',
          data: { id: this.id, status: 2, remark: this.value }
        })
        .then(res => {
          this.$Message.success('已通知对方');
        });
    },
    cancel() {},
    oDelete(id, index) {
      this.$Modal.confirm({
        title: '确定',
        content: '<p>确认删除该简历</p>',
        onOk: () => {
          this.$axios.request({ url: 'api/qiye/companyResume/' + id, method: 'delete' }).then(res => {
            this.list.splice(index, 1);
          });
        },
        onCancel: () => {}
      });
    },
    dowmload(item) {
      this.$Modal.confirm({
        title: '确定',
        content: '<p>确认下载该简历</p>',
        onOk: () => {
          this.downloadResume(item.id);
        },
        onCancel: () => {}
      });
    },
    downloadResume(id) {
      this.$axios.request({ url: 'api/qiuzhi/companyResumeFiles/' + id }).then(res => {
        if (res.data) {
          downloadFile(res.data);
        }
      });
    },
    sent() {
      this.showInterviewModal = false;
      this.showResumeModal = false;
    }
  }
};
</script>

<style lang="less" scoped>
.jianli-container {
  min-height: 600px;
}

.list {
  .item {
    display: flex;
    align-items: center;
    height: 100px;
    margin-bottom: 1px;
    background: #fff;
    color: #363e4f;
    > img {
      width: 52px;
      height: 52px;
      margin-left: 40px;
    }
    .zhiwei {
      margin-left: 20px;
      flex: 1;
      .title {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }
    .status {
      flex: 1;
      font-size: 14px;
    }
    .mianshi {
      color: #0491ff;
    }
    .jujue {
      color: #ff364e;
    }
    .weitongguo {
      color: #363e4f;
      opacity: 0.5;
    }
    .tongguo {
      color: #33c5d7;
    }
    .btns {
      display: flex;
      margin-right: 45px;
      font-size: 14px;
      position: relative;
      > .btn {
        padding: 15px;
        color: #d6000f;
        cursor: pointer;
      }
      .btnList {
        position: absolute;
        z-index: 1;
        top: 45px;
        left: -80px;
        width: 129px;
        background-color: #fff;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
        > div {
          height: 36px;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
        }
        > div:hover {
          background: rgba(72, 146, 253, 0.1);
        }
      }
    }
  }
}

.action {
  margin-right: 10px;
}

::v-deep .ivu-table-cell {
  padding: 0 5px;
}
</style>
